"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTextField = void 0;
const react_1 = __importDefault(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const formik_1 = require("formik");
//eslint-disable-next-line
function FTextField(props) {
    const [field, meta] = formik_1.useField(props.field);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextField_1.default, Object.assign({}, props, field, { error: Boolean(meta.touched && meta.error), helperText: meta.touched && meta.error ? meta.error : '' }))));
}
exports.FTextField = FTextField;
